let mime = require("mime");
let dayjs = require("dayjs");
const phoneMask = (data) => {
    if(!data)
        return ""
    if(data.length === 13){
        let code = data.substr(0,2)
        let ddd = data.substr(2,2)
        let first_five = data.substr(4,5)
        let last_four = data.substr(9,4)
        return `+${code} (${ddd}) ${first_five}-${last_four}`
    }
    if(data.length === 12){
        let code = data.substr(0,2)
        let ddd = data.substr(2,2)
        let first_five = data.substr(4,4)
        let last_four = data.substr(8,4)
        return `+${code} (${ddd}) ${first_five}-${last_four}`
    }
    return data
}
function _debounce(func, wait) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      const later = function() {
        timeout = null;
        func.apply(context, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
};
const fileDetailsFromURL = (url) => {
    let parsed = new URL(url)
    let paths = parsed.pathname.split("/")
    let size = paths.length
    let fname = paths[size-1]
    let mtype = mime.lookup(fname, "image/jpeg")
    let ext = mime.extension(mtype) || "jpeg"
    return { filename: fname, contentType: mtype, ext: ext }
}
const getAvatar = (url, type) => {
    if(url)
        return url
    switch(type){
        case "facebook":
            return "https://storage.4bytes.com.br/public-uploads/icons/facebook.png"
        case "wa":
            return "https://storage.4bytes.com.br/public-uploads/icons/whatsapp.png"
        case "waba":
            return "https://storage.4bytes.com.br/public-uploads/icons/whatsapp-business.png"
        case "sms":
            return "https://storage.4bytes.com.br/public-uploads/icons/sms.png"
        case "instagram":
            return "https://storage.4bytes.com.br/public-uploads/icons/instagram.png"
        default:
            return "https://storage.4bytes.com.br/public-uploads/icons/telegram.png"
    }
}
const channelTypeLabel = (type) => {
    switch(type){
        case "facebook":
        return "Facebook"
        case "wa":
        return "WhatsApp"
        case "waba":
        return "WhatsApp Business"
        case "sms":
        return "SMS"
        case "instagram":
        return "Instagram"
        default:
        return "Telegram"
    }
}
const customize_dayjs = () => {
    var relativeTime = require('dayjs/plugin/relativeTime');
    var updateLocale = require('dayjs/plugin/updateLocale');
    var localeData = require('dayjs/plugin/localeData')
    var weekday = require('dayjs/plugin/weekday')
    var duration = require('dayjs/plugin/duration')

    dayjs.extend(weekday)
    dayjs.extend(updateLocale);
    dayjs.extend(relativeTime);
    dayjs.extend(localeData);
    dayjs.extend(duration)
    dayjs.updateLocale('pt-BR', {
        relativeTime: {
            future: "em %s",
            past: "%s atrás",
            s: 'alguns segundos',
            m: "um minuto",
            mm: "%d minutos",
            h: "uma hora",
            hh: "%d horas",
            d: "um dia",
            dd: "%d dias",
            M: "um mês",
            MM: "%d meses",
            y: "um ano",
            yy: "%d anos"
        }
    });
    dayjs.updateLocale('pt', {
        relativeTime: {
            future: "em %s",
            past: "%s atrás",
            s: 'alguns segundos',
            m: "um minuto",
            mm: "%d minutos",
            h: "uma hora",
            hh: "%d horas",
            d: "um dia",
            dd: "%d dias",
            M: "um mês",
            MM: "%d meses",
            y: "um ano",
            yy: "%d anos"
        }
    });
    dayjs.updateLocale('en', {
        relativeTime: {
            future: "em %s",
            past: "%s atrás",
            s: 'alguns segundos',
            m: "um minuto",
            mm: "%d minutos",
            h: "uma hora",
            hh: "%d horas",
            d: "um dia",
            dd: "%d dias",
            M: "um mês",
            MM: "%d meses",
            y: "um ano",
            yy: "%d anos"
        }
    });
}
const hasRole = (role, roles) => {
    return roles.findIndex((item)=> item === role) !== -1
}
module.exports = {
    hasRole,
    phoneMask,
    channelTypeLabel,
    getAvatar,
    fileDetailsFromURL,
    _debounce,
    customize_dayjs
}